import { useEffect, useState } from 'react';

import { BroadcastStatus } from '../../../../../../types';

/** Длительность идущей трансляции в секундах. */
export const useBroadcastDuration = (broadcastStatus: BroadcastStatus, startedAt?: number): number => {
    const [duration, setDuration] = useState(0);

    useEffect(() => {
        if (broadcastStatus !== BroadcastStatus.STARTED || !startedAt) {
            return undefined;
        }

        const update = () => setDuration(Math.round(Date.now() / 1000 - startedAt));

        update();
        const timer = setInterval(update, 1000);

        return () => clearInterval(timer);
    }, [broadcastStatus, startedAt]);

    return duration;
};
